import { SnackbarProvider } from 'notistack';
import React from 'react';
import Root from './root';
import CssBaseline from '@mui/material/CssBaseline';

import { ThemeProvider } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { CacheProvider } from '@emotion/react';
import { EmotionCache } from '@emotion/cache';
import theme from './theme';
import { DialogProvider } from 'components/Dialog/DialogProvider';

interface AppProps {
  cache: EmotionCache;
}
const App: React.FC<AppProps> = ({ cache }) => {
  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles={() => ({})} />

        <SnackbarProvider
          maxSnack={3}
          autoHideDuration={3000}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <CssBaseline />
          <DialogProvider>
            <Root />
          </DialogProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default App;
